import React from 'react';
import Styles from './MediaGrid.module.scss'; // Import CSS for styling

export const MediaGrid = ({ mediaLinks, openOnClick = true, isImage, isVideo, allowOverflow = true }) => {

    const baseUrl = process.env.REACT_APP_GLOBAL_MEDIA_URL || 'https://global-media.topgrep.com';

    const getFullUrl = (link) => {
        if (link.startsWith('http://') || link.startsWith('https://')) {
            return link;
        }

        return `${baseUrl}${link}`;
    };
    const renderMedia = () => {
        return mediaLinks?.map((link, index) => {
            const fullLink = getFullUrl(link);
            let mediaItem = null;

            if ((isImage) || (link.endsWith('.jpg') || link.endsWith('.jpeg') || link.endsWith('.png') || link.endsWith('.gif'))) {
                mediaItem = <img
                    src={fullLink}
                    alt={`${index}`}
                    onClick={() => { if (openOnClick) window.open(fullLink, '_blank') }}
                    style={{ cursor: openOnClick ? 'pointer' : 'default' }}
                />;
            } else if (link.endsWith('.mp4')
                || link.endsWith('.webm')
                || link.endsWith('.ogg')
                || link.endsWith('.mov')
                || link.endsWith('.mkv')
            ) {
                mediaItem = (
                    <video controls>
                        <source src={fullLink} type={`video/${link.split('.').pop()}`} />
                        Your browser does not support the video tag.
                    </video>
                );
            } else {
                mediaItem = <embed
                    src={fullLink}
                    height="100%"
                    width="100%"
                />;
            }

            return <div key={index} className={Styles.mediaItem} style={{ overflow: allowOverflow ? 'auto' : '' }}>{mediaItem}</div>;
        });
    };

    return <div className={Styles.mediaGrid}>{renderMedia()}</div>;
};
